import React from 'react'
import './authLayout.scss'

export default function AuthLayout({children}) {
  return (
    <div id='AuthLayout'>{children}</div>
  )
}
